export default "__VITE_ASSET__BYkbvzLM__"